import React from 'react';
import { FaSearch, FaCalendarAlt } from 'react-icons/fa';
import { DateFilter } from '../../utils/orderUtils';

interface UserOrdersFiltersProps {
  searchTerm: string;
  onSearchChange: (term: string) => void;
  dateFilter: DateFilter;
  onDateFilterChange: (filter: DateFilter) => void;
}

const UserOrdersFilters: React.FC<UserOrdersFiltersProps> = ({
  searchTerm,
  onSearchChange,
  dateFilter,
  onDateFilterChange,
}) => {
  return (
    <div className="bg-white/80 backdrop-blur-sm rounded-xl shadow-lg p-6 border border-white/50">
      <div className="flex flex-col lg:flex-row gap-4">
        {/* Arama */}
        <div className="flex-1 relative">
          <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Sipariş no veya ürün adıyla ara..."
            value={searchTerm}
            onChange={e => onSearchChange(e.target.value)}
            className="w-full pl-12 pr-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white/70 placeholder-gray-400 transition-all"
          />
        </div>

        {/* Tarih Filtresi */}
        <div className="relative">
          <FaCalendarAlt className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <select
            value={dateFilter}
            onChange={e => onDateFilterChange(e.target.value as DateFilter)}
            className="pl-12 pr-8 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white/70 min-w-[140px] transition-all"
          >
            <option value="all">Tüm Zamanlar</option>
            <option value="today">Bugün</option>
            <option value="week">Bu Hafta</option>
            <option value="month">Bu Ay</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default UserOrdersFilters;
